import React from 'react'
import DialogSubscriberDetails from './DialogSubscriberDetails'
import DialogEditSubscriberDetails from './DialogEditSubscriberDetails'
import DialogConfirmApprove from './dialogs/DialogConfirmApprove'
import DialogConfirmReject from './dialogs/DialogConfirmReject'
import SubscriberMembershipCardDialog from '../membershipCard/SubscriberMembershipCardDialog'
import SubscriberMembershipCardListDialog from '../membershipCard/SubscriberMembershipCardListDialog'

const SUBSCRIBER_DETAILS_DIALOG = 'isOpenDetailsDialog'
const SUBSCRIBER_EDIT_DETAILS_DIALOG = 'isOpenEditDetailsDialog'
const SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA = 'isOpenMembershipCardDialogData'
const SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA =
  'isOpenMembershipCardListDialogData'
const SUBSCRIBER_APPROVE_DIALOG = 'isOpenApproveDialog'
const SUBSCRIBER_REJECT_DIALOG = 'isOpenRejectDialog'
const SUBSCRIBER_QUICK_ACTION = 'isQuickAction'

export default (props) => {
  let {
    localState,
    approveOrReject,
    openOrCloseDetailsDialog,
    openOrCloseEditDetailsDialog,
    updateCrmFields,
    openMembershipCardDialog,
    closeMembershipCardDialog,
    pageData,
    closeMembershipCardListDialog,
    openMembershipCardDetailDialog,
    openMembershipCardListDialog,
    isHideGroup,
  } = props

  const openingMembershipCardSubscriberData =
    localState[SUBSCRIBER_MEMBERSHIP_CARD_DIALOG_DATA]
  const openingMembershipCardSubscriberListData =
    localState[SUBSCRIBER_MEMBERSHIP_CARD_LIST_DIALOG_DATA]
  return (
    <>
      {localState[SUBSCRIBER_DETAILS_DIALOG] && (
        <DialogSubscriberDetails
          approveOrReject={approveOrReject}
          openOrCloseDetailsDialog={openOrCloseDetailsDialog}
          openOrCloseEditDetailsDialog={openOrCloseEditDetailsDialog}
          updateCrmFields={updateCrmFields}
          subscriber={localState.subscriber}
          openMembershipCardDialog={openMembershipCardDialog}
          openMembershipCardListDialog={openMembershipCardListDialog}
        />
      )}

      {localState[SUBSCRIBER_EDIT_DETAILS_DIALOG] && (
        <DialogEditSubscriberDetails
          openOrCloseEditDetailsDialog={openOrCloseEditDetailsDialog}
          subscriber={localState.subscriber}
          updateCrmFields={updateCrmFields}
          isHideGroup={isHideGroup}
          isQuickAction={localState[SUBSCRIBER_QUICK_ACTION]}
        />
      )}

      {localState[SUBSCRIBER_APPROVE_DIALOG] && (
        <DialogConfirmApprove approveOrReject={approveOrReject} />
      )}
      {localState[SUBSCRIBER_REJECT_DIALOG] && (
        <DialogConfirmReject approveOrReject={approveOrReject} />
      )}

      {openingMembershipCardSubscriberData && (
        <SubscriberMembershipCardDialog
          onClose={closeMembershipCardDialog}
          onSaved={() => {
            pageData && pageData.refetchData()
          }}
          subscriber={openingMembershipCardSubscriberListData}
          membershipCard={openingMembershipCardSubscriberData}
        />
      )}

      {openingMembershipCardSubscriberListData && (
        <SubscriberMembershipCardListDialog
          onClose={closeMembershipCardListDialog}
          openMembershipCardDetailDialog={openMembershipCardDetailDialog}
          subscriber={openingMembershipCardSubscriberListData}
        />
      )}
    </>
  )
}
